import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [{
	name: 'Forms',
	url: '/forms',
	icon: 'dashboard',
}];

export default class Anti_Virus_Inspection_Waiver extends Framework.Components.View {

	render() {
		let {match, baseUrl} = this.props

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Anti Virus Inspection Waiver",
				url: `/forms/anti_virus_inspection_waiver`,
				icon: 'book',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>
				<Objects.MandatoryAntiVirusInspectionWaiver
					id={match.params.id}
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					updateName={this.updateName}
					baseUrl={baseUrl}
					goBack={true}
				/>
			</div>
		);
	}
}

